import RegistrationTable from 'components/RegistrationTable/RegistrationTable';
import Title from 'components/Title/Title';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withGlobalRegistrationPageQuery, {
  WithGlobalRegistrationPageQueryProps,
} from 'enhancers/withGlobalRegistrationPageData';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import CountryRegistration from 'pages/CountryRegistration/CountryRegistration';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import styled from 'styled-components';
import Section from 'wrappers/Section/Section';

type Props = WithGlobalRegistrationPageQueryProps &
  WithLanguageProps &
  IWithCountryProps;

export const GlobalRegistrationPage: React.SFC<Props> = props => {
  if (props.country !== 'global') {
    return <CountryRegistration />;
  }
  if (!props.loading && props.data && props.data.fetch.Common.Page) {
    const Page = props.data.fetch.Common.Page;
    const titleColor = props.data.fetch.Common.Page.TitleColor || '#333';
    const subtitleColor = props.data.fetch.Common.Page.SubtitleColor || '#333';
    const background =
      props.data.fetch.Common.Page.BackgroundImage &&
      props.data.fetch.Common.Page.BackgroundImage.src
        ? `url(${props.data.fetch.Common.Page.BackgroundImage.src})`
        : props.data.fetch.Common.Page.BackgroundColor || '#fff';
    return (
      <Container subtitleColor={subtitleColor} background={background}>
        <Section>
          <Title style={{ color: titleColor }}>
            {props.getText(Page.Title)}
          </Title>
          <Markdown
            className="registration-md"
            source={props.getText(Page.Subtitle)}
          />
          <RegistrationTable items={Page.Continents} />
        </Section>
      </Container>
    );
  }
  return null;
};

const Container = styled.div<{ subtitleColor: string; background: string }>`
  padding: 16px;
  .registration-md {
    color: ${p => p.subtitleColor};
  }
  background: ${p => p.background};
  background-position: center;
  background-size: cover;
`;

export default withLanguageState(
  withCountry(withGlobalRegistrationPageQuery(GlobalRegistrationPage))
);



// WEBPACK FOOTER //
// ./src/pages/GlobalRegistrationPage/GlobalRegistrationPage.tsx